import { useQuery } from '@tanstack/react-query';
import { ColDef, ValueFormatterParams } from 'ag-grid-community';

import Card from '~/shared/components/Card';
import { Volume, VolumeResponse } from '~/shared/types/api';
import { useXFetch } from '~/shared/utils/useXFetch';
import { formatBytes } from '~/shared/utils/formatNumber';
import Table from '~/shared/components/Table';
import Typography from '~/shared/components/Typography';

import { baseUrl } from '../FleetManagerPage/helpers';
import { getFilterSearchParams } from '../common/helpers';

export default function DatafyVolumes({ volume }: { volume: Volume }) {
  const { volumeId } = volume;

  const qs = new URLSearchParams(
    getFilterSearchParams([
      {
        field: 'monitoring',
        value: 'datafied',
        op: 'equals',
      },
      {
        field: 'sourceVolume',
        op: 'equals',
        value: volumeId!,
      },
    ])
  );

  const api = useXFetch();
  const { data } = useQuery({
    queryKey: ['getDatafiedVolumes', volumeId],
    queryFn: async () => await api<VolumeResponse>(`${baseUrl}?${qs.toString()}`),
    refetchOnWindowFocus: false,
  });

  return (
    <Card className="flex flex-col">
      <Typography variant="p1" className=" mb-[30px]">
        Datafy Volumes
      </Typography>

      <Table columnDefs={columnDefs} rowData={data?.volumes || []} headerHeight={40} />
    </Card>
  );
}

const columnDefs: ColDef<Volume>[] = [
  {
    headerName: 'Datafy Volume ID',
    field: 'volumeId',
    flex: 1,
    minWidth: 200,
  },
  {
    headerName: 'Size',
    field: 'diskSize',
    flex: 1,
    cellStyle: { color: '#2151F5' },
    valueFormatter: ({ value }: ValueFormatterParams<Volume>) => formatBytes(value),
  },
  {
    headerName: 'Type',
    field: 'diskType',
    flex: 1,
    cellStyle: { color: '#2151F5' },
  },
];
